import React from "react";
import { Rnd } from "react-rnd";
import detect from "detect-browser";

const AudioVideo = ({
  isVisible,
  isVideoAvailable,
  direction,
  kioskmode,
  textIsVisible,
}) => {
  const visibleClass = isVisible ? "" : " display-none";

  const video = direction => {
    var id = direction === "local" ? "local-video" : "remote-video";
    var muted = direction === "local" ? true : false;
    var classes = "";
    if (kioskmode === true) {
      classes =
        direction === "local" ? "kiosk-local-video" : "kiosk-remote-video";
    } else {
      classes =
        direction === "local"
          ? "local-video"
          : textIsVisible
          ? "remote-video video-width"
          : "remote-video";
    }

    return (
      <video id={id} muted={muted} className={classes} autoPlay={true}>
        <track kind="captions" src="noCaptions.vtt" />
        <track
          kind="descriptions"
          src="noDescription.vtt"
          srcLang="en"
          label="english_description"
        ></track>
      </video>
    );
  };

  const audio = direction => {
    const id = direction === "local" ? "local-audio" : "remote-audio";
    return (
      <audio className="min-width-height-100-procent" id={id} autoPlay={true}>
        <track kind="captions" src="noCaptions.vtt" />
      </audio>
    );
  };

  const mediaElement = isVideoAvailable ? video(direction) : audio();

  const id =
    direction === "local" ? "local-video-container" : "remote-video-container";
  var flexbox = kioskmode === true ? "display-flex" : "";
  var textBox = textIsVisible === true ? " video-container-width" : "";
  var retur =
    direction === "local" && kioskmode === false ? (
      <Rnd
        className={visibleClass}
        bounds={".callViewContainer"}
        lockAspectRatio={true}
        enableResizing={{
          top: false,
          right: false,
          bottom: false,
          left: false,
          topRight: false,
          bottomRight:
            detect.detect().name.toLowerCase() === "ie" ? false : true,
          bottomLeft: false,
          topLeft: false,
        }}
        default={{
          x: 0,
          y: 0,
          width: "15%",
        }}
      >
        {mediaElement}
      </Rnd>
    ) : (
      <div
        id={id}
        className={
          flexbox +
          visibleClass +
          textBox +
          (kioskmode === true ? " local-video-container-kiosk" : "")
        }
      >
        {mediaElement}
      </div>
    );
  return retur;
};

export default AudioVideo;






// WEBPACK FOOTER //
// ./src/components/AudioVideo.jsx